<div class="row page-header">
    <div class="col-12">
        <h1>Fuel Analytics <small>View and analyize fuel usage</small></h1>
    </div>
</div>
@if (!isInitialLoading) {
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="0" [destroyOnHide]="false">
            <a ngbNavLink>Truck Chart</a>
            <ng-template ngbNavContent>
                <div class="row">
                    @if (truckChartData) {
                        <div class="col-lg-12">
                            <wj-flex-chart
                                appAutoSize
                                [itemsSource]="truckChartData.points"
                                [bindingX]="'label'"
                                [chartType]="truckChartData.chartType"
                                [header]="truckChartData.title"
                                [legendToggle]="true"
                            >
                                <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                                <wj-flex-chart-axis
                                    [wjProperty]="'axisY'"
                                    [title]="'Gallons'"
                                    [format]="'N2'"
                                    [min]="0"
                                ></wj-flex-chart-axis>
                                @for (serie of truckChartData.series; track serie) {
                                    <wj-flex-chart-series [binding]="serie.binding" [name]="serie.name"> </wj-flex-chart-series>
                                }
                            </wj-flex-chart>
                        </div>
                    }
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Fuel Totals</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar" style="margin-top: 15px">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="totalsGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridTotals" [name]="'Fuel Totals'"></grid-export>
                                    <div class="input-header-group">
                                        <span class="input-header">Start Date</span>
                                        <wj-input-date
                                            [(ngModel)]="startDate"
                                            (ngModelChange)="refresh()"
                                            name="startDate"
                                            style="width: 125px; height: 32px; margin-top: 4px"
                                        ></wj-input-date>
                                    </div>
                                    <div class="input-header-group">
                                        <span class="input-header">End Date</span>
                                        <wj-input-date
                                            [(ngModel)]="endDate"
                                            (ngModelChange)="refresh()"
                                            name="endDate"
                                            style="width: 125px; height: 32px; margin-top: 4px"
                                        ></wj-input-date>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="totalsGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridTotals"
                                    #gridTotals
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="totalsGrid.initialize(gridTotals)"
                                    (destroy)="totalsGrid.destroy()"
                                    [itemsSource]="totalsGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Category'"
                                        [binding]="'equipmentCategory'"
                                        [width]="350"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Gallons'" [binding]="'gallons'" [width]="150"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridTotals"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Fuel Rates</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="rateGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridRate" [name]="'Fuel Rates'"></grid-export>
                                    <wj-input-date
                                        [(ngModel)]="startDate"
                                        (ngModelChange)="refresh()"
                                        name="startDate"
                                        style="width: 125px"
                                    ></wj-input-date>
                                    <wj-input-date
                                        [(ngModel)]="endDate"
                                        (ngModelChange)="refresh()"
                                        name="date"
                                        style="width: 125px"
                                    ></wj-input-date>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="rateGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridRate"
                                    #gridRate
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="rateGrid.initialize(gridRate)"
                                    [itemsSource]="rateGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Category'"
                                        [binding]="'equipmentCategory'"
                                        [width]="350"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Gallons Per Hour'"
                                        [binding]="'gallonsPerHour'"
                                        [width]="150"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Hours Per Gallon'"
                                        [binding]="'hoursPerGallon'"
                                        [width]="150"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridRate"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="12" [destroyOnHide]="false">
            <a ngbNavLink>Fuel Burn Rate</a>
            <ng-template ngbNavContent>
                <app-burn-rate [active]="active"></app-burn-rate>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Record Validation And Repair</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="grid"
                                        [canEdit]="canEdit"
                                        [showAdd]="false"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                                    <grid-export [grid]="mainGrid" [name]="'Fuel Records'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="mainGrid"
                                    #mainGrid
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="grid.initialize(mainGrid)"
                                    (destroy)="grid.destroy()"
                                    [itemsSource]="grid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Fuel Date'"
                                        [binding]="'date'"
                                        [format]="'d'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Fuel Out'" [binding]="'source'" [width]="115"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Fuel In'" [binding]="'vehicle'" [width]="115"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Fuel In Category'"
                                        [binding]="'equipmentCategory'"
                                        [width]="240"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Gallons'" [binding]="'gallons'" [width]="105"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Fuel Capacity'"
                                        [binding]="'fuelCapacity'"
                                        [width]="90"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Hour Meter'"
                                        [binding]="'meter'"
                                        [width]="90"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'User'" [binding]="'userName'" [width]="180"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job'" [binding]="'jobId'" [width]="90"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="180"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Created By'" [binding]="'userName'" [width]="180"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Last Modified By'"
                                        [binding]="'lastModifiedByName'"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Last Modified On'"
                                        [binding]="'lastModifiedOn'"
                                        [format]="'MM/dd/yy hh:mm tt'"
                                        [width]="180"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="4" [destroyOnHide]="false">
            <a ngbNavLink>Negative Hours Validation</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="negHoursGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridNegHours" [name]="'Fuel Rate Validation'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="negHoursGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridNegHours"
                                    #gridNegHours
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="negHoursGrid.initialize(gridNegHours)"
                                    [itemsSource]="negHoursGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Category'"
                                        [binding]="'equipmentCategory'"
                                        [width]="250"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Hours'" [binding]="'meter'" [width]="150"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="150"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridNegHours"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="5" [destroyOnHide]="false">
            <a ngbNavLink>Rate Too High (> 20 GPH) Validation</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="tooHighRateGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridTooHighRate" [name]="'Fuel Rate Validation'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="tooHighRateGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridTooHighRate"
                                    #gridTooHighRate
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="tooHighRateGrid.initialize(gridTooHighRate)"
                                    [itemsSource]="tooHighRateGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Category'"
                                        [binding]="'equipmentCategory'"
                                        [width]="250"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Hours'" [binding]="'meter'" [width]="150"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Gallons'" [binding]="'gallons'" [width]="150"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="150"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridTooHighRate"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="6" [destroyOnHide]="false">
            <a ngbNavLink>No Hours or Gallons Validation</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="noHoursGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridNoHours" [name]="'Fuel Rate Validation'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="noHoursGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridNoHours"
                                    #gridNoHours
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="noHoursGrid.initialize(gridNoHours)"
                                    [itemsSource]="noHoursGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Category'"
                                        [binding]="'equipmentCategory'"
                                        [width]="250"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Hours'" [binding]="'meter'" [width]="150"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Gallons'" [binding]="'gallons'" [width]="150"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="150"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridNoHours"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="7" [destroyOnHide]="false">
            <a ngbNavLink>GPS Hours Comparison</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="gpsHoursGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridGpsHours" [name]="'Fuel Rate Validation'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="gpsHoursGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridGpsHours"
                                    #gridGpsHours
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="gpsHoursGrid.initialize(gridGpsHours)"
                                    [itemsSource]="gpsHoursGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'GPS Result'"
                                        [binding]="'gpsMeterType'"
                                        [width]="400"
                                        [dataMap]="gpsResultMap"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="250"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Category'"
                                        [binding]="'equipmentCategory'"
                                        [width]="250"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Fuel Record Hours'"
                                        [binding]="'meter'"
                                        [width]="150"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'GPS Hours'"
                                        [binding]="'gpsMeter'"
                                        [width]="150"
                                        [format]="'n0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Gallons'" [binding]="'gallons'" [width]="150"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="150"></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridGpsHours"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="8" [destroyOnHide]="false" [hidden]="true">
            <a ngbNavLink>Fuel Transport Totals</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="transportsGrid"></action-toolbar-count>
                                    <grid-export [grid]="gridTransports" [name]="'Fuel Rate Validation'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="transportsGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridTransports"
                                    #gridTransports
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="transportsGrid.initialize(gridTransports)"
                                    [itemsSource]="transportsGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Transport'" [binding]="'transport'" [width]="160"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Fill Date 1'"
                                        [binding]="'fillDate1'"
                                        [format]="'MM/dd/yy hh:mm tt'"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Fill Date 2'"
                                        [binding]="'fillDate2'"
                                        [format]="'MM/dd/yy hh:mm tt'"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Gallons In'"
                                        [binding]="'gallonsIn'"
                                        [width]="160"
                                        [format]="'n0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Gallons Out'"
                                        [binding]="'gallonsOut'"
                                        [width]="160"
                                        [format]="'n0'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridTransports"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="9" [destroyOnHide]="false">
            <a ngbNavLink>Fuel Transport Totals</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="transportsTotalsGrid"></action-toolbar-count>

                                    <grid-export [grid]="gridTransportsTotals" [name]="'Fuel Rate Validation'"></grid-export>

                                    <wj-combo-box
                                        name="selectedTimeUnit"
                                        [(ngModel)]="selectedTimeUnit"
                                        [itemsSource]="timeUnitOptions"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [isRequired]="true"
                                        (ngModelChange)="refresh()"
                                    >
                                    </wj-combo-box>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <grid-column-group [grid]="transportsTotalsGrid"></grid-column-group>
                                <wj-flex-grid
                                    id="gridTransportsTotals"
                                    #gridTransportsTotals
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="transportsTotalsGrid.initialize(gridTransportsTotals)"
                                    [itemsSource]="transportsTotalsGrid.view"
                                    [itemFormatter]="itemFormatter"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Date'"
                                        [binding]="'date'"
                                        [format]="'MM/dd/yyyy'"
                                        [width]="120"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'TI116f'"
                                        [binding]="'tI116f'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'TO116f'"
                                        [binding]="'tO116f'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'TI145f'"
                                        [binding]="'tI145f'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'TO145f'"
                                        [binding]="'tO145f'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'TI163f'"
                                        [binding]="'tI163f'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'TO163f'"
                                        [binding]="'tO163f'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'TI145n'"
                                        [binding]="'tI145n'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'TO145n'"
                                        [binding]="'tO145n'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'TI163n'"
                                        [binding]="'tI163n'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'TO163n'"
                                        [binding]="'tO163n'"
                                        [width]="100"
                                        [format]="'n1'"
                                        [align]="'right'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridTransportsTotals"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="10" [destroyOnHide]="false">
            <a ngbNavLink>Lifetime Meter Reconciliation</a>
            <ng-template ngbNavContent>
                <app-lifetime-meter [active]="active"></app-lifetime-meter>
            </ng-template>
        </li>
        <li [ngbNavItem]="11" [destroyOnHide]="false">
            <a ngbNavLink>Vista Hours Variance</a>
            <ng-template ngbNavContent>
                <app-hours-variance [active]="active"></app-hours-variance>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
}
